import { formatPrice } from "./priceUtils";

export default function displayWithSuffix({
  locale,
  values,
  suffix,
}: {
  locale: string;
  values?: (string | number)[] | null;
  suffix?: string | null;
}) {
  if (!values) return "";
  const [min, max] = values;
  if (!suffix) return `${min} - ${max}`;
  if (
    suffix === "%CURRENCY%" &&
    typeof min === "number" &&
    typeof max === "number"
  ) {
    return `${formatPrice(min, locale)} - ${formatPrice(max, locale)}`;
  }
  return `${min} ${suffix} - ${max} ${suffix}`;
}
